/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { styled, Box, Typography } from "@mui/material";

export const StyledSubSection = styled("div")({
  display: "flex",
  gap: "10px",
  margin: "20px 0px",
});

export const ListItem = ({ label, value }) => {
  return (
    <Box
      sx={{
        marginBottom: "8px",
        flexGrow: 1,
        display: "flex",
        alignItems: "flex-start",
        paddingTop: "15px",
      }}
    >
      <span
        style={{
          fontWeight: 600,
          lineHeight: "24px",
          fontSize: "16px",
          minWidth: "200px",
          marginRight: "16px",
          flexShrink: 0,
        }}
      >
        {label}:
      </span>
      <span
        style={{
          lineHeight: "24px",
          fontSize: "16px",
          wordBreak: "break-word",
        }}
      >
        {value ? value : "-"}
      </span>
    </Box>
  );
};

export const SubSectionTitle = styled(Typography)({
  fontWeight: "600",
  color: "black",
  fontSize: "18px",
});

export const SectionDescription = styled(Typography)({
  fontWeight: "400",
  color: "black",
  fontSize: "15px",
  marginTop: "4px",
});
